/**
 * Created by Timur on 27.07.2026
 */

const BalloonRiseWindow = Prefab.createWindow("balloon_rise", "balloon_rise_window_prefab_json");
